module.exports = __webpack_public_path__ + "static/media/shader.5caf77f9.frag";


//////////////////
// WEBPACK FOOTER
// ./src/lib/vendor/postprocessing/materials/glsl/bokeh/shader.frag
// module id = 265
// module chunks = 0